import { type Writable, writable } from 'svelte/store';

export const activeRouteComponent: Writable<any> = writable(null);
